import { render } from "./IconCameraCinema.vue?vue&type=template&id=2092b225"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCameraCinema.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2092b225"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2092b225', __exports__)) {
    api.reload('2092b225', __exports__)
  }
  
  module.hot.accept("./IconCameraCinema.vue?vue&type=template&id=2092b225", () => {
    api.rerender('2092b225', render)
  })

}


export default __exports__